<script setup>
  import {nextTick, ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import PatientsPatientContactsData from "@pages/Patients/Components/PatientContactsData.vue";

  defineOptions({
    name: "ComponentPatientContactsDialog",
  });

  defineProps({
    patient: {
      type: Object,
      required: true,
    },
  });

  const refPatientContactsDialog = ref(null);
  const refPatientContactsData = ref(null);
  const internalPendingContact = ref(null);

  const open = (pendingContact) => {
    if (pendingContact !== undefined) {
      internalPendingContact.value = pendingContact;
    }

    refPatientContactsDialog.value.open();
  };

  const searchInAddressBook = (contact, pendingContact) => {
    // set the optional pendingContact (visible in the background of the addressbook)
    if (pendingContact !== undefined) {
      internalPendingContact.value = pendingContact;
    }
    // open the contacts dialog
    refPatientContactsDialog.value.open();

    // then open the addressbook layer in front of the contacts dialog
    nextTick(() => {
      refPatientContactsData.value.openAddressBook(contact);
    });
  };

  const closeDialog = () => {
    refPatientContactsDialog.value.close();
  };

  defineExpose({
    open,
    closeDialog,
    searchInAddressBook,
  });
</script>

<template>
  <ComponentDialog
    ref="refPatientContactsDialog"
    dialog-width="large"
    dialog-type="abort"
    cancel-label="Schließen"
    :test-id="getTestId('contacts')"
  >
    <template #content>
      <PatientsPatientContactsData
        ref="refPatientContactsData"
        within-dialog
        :patient="patient"
        :pending-contact="internalPendingContact"
      />
    </template>
  </ComponentDialog>
</template>
